module.exports = __webpack_public_path__ + "static/media/rect-minus.7b2f80c3.svg";